import { HttpError } from "ra-core";

const globalErrorHandler = (error) => {
    let customMessage = "حدث خطأ اثناء معالجة طلبك";
    
    // Check if this is a network connectivity error
    const isNetworkError = error.message === "Load failed" || 
                          error.message === "Failed to fetch" ||
                          error.name === "NetworkError" ||
                          error.code === "NETWORK_ERROR";

    try {
        if (error.body?.graphQLErrors?.length > 0) {
            const graphqlError = error.body.graphQLErrors[0];
            customMessage =
                graphqlError.extensions?.internal?.error?.message ||
                graphqlError.message ||
                customMessage;
        } else if (error.body?.errors?.length > 0) {
            const graphqlError = error.body.errors[0];
            customMessage =
                graphqlError.extensions?.internal?.error?.message ||
                graphqlError.message ||
                customMessage;
        } else if (error.message) {
            if (isNetworkError) {
                customMessage = "فشل في الاتصال بالخادم - يرجى التحقق من الاتصال بالإنترنت";
            } else {
                customMessage = error.message;
            }
        }
    } catch (e) {
        console.error("Error parsing the GraphQL error:", e);
    }

    // Add more context for debugging
    console.error("Global error handler caught an error:", {
        message: error.message,
        status: error.status,
        name: error.name,
        code: error.code,
        isNetworkError,
        url: error.config?.url || 'unknown',
        method: error.config?.method || 'unknown'
    });

    throw new HttpError(customMessage, error.status || 400, error);
};

export const wrapDataProviderWithGlobalErrorHandler = (dataProvider) => {
    return new Proxy(dataProvider, {
        get(target, propKey) {
            // Intercept method calls
            const origMethod = target[propKey];
            if (typeof origMethod !== "function") {
                return origMethod; // Return non-method properties as-is
            }

            // Wrap all CRUD operations
            return async (...args) => {
                let retryCount = 0;
                const maxRetries = 2;
                
                while (retryCount <= maxRetries) {
                    try {
                        return await origMethod.apply(target, args);
                    } catch (error) {
                        const isNetworkError = error.message === "Load failed" || 
                                              error.message === "Failed to fetch" ||
                                              error.name === "NetworkError" ||
                                              error.code === "NETWORK_ERROR";
                        
                        // Only retry network errors, not application errors
                        if (isNetworkError && retryCount < maxRetries) {
                            retryCount++;
                            const delay = Math.pow(2, retryCount - 1) * 1000; // 1s, 2s
                            console.warn(`Network error occurred, retrying in ${delay}ms (attempt ${retryCount}/${maxRetries})`);
                            
                            await new Promise(resolve => setTimeout(resolve, delay));
                            continue;
                        }
                        
                        // If all retries failed or it's not a network error, use global error handler
                        globalErrorHandler(error);
                    }
                }
            };
        },
    });
};
